// extracted by mini-css-extract-plugin
module.exports = {"title":"style__title__GTuTV","overallTable":"style__overallTable__S6s09"};